export default __webpack_public_path__ + "static/media/workspace.b6d6740b.svg";